// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"TertiaryNav__header--2zZVX","left":"TertiaryNav__left--1kR7R","main":"TertiaryNav__main--33C9V"};